// src/AuthGate.tsx
import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { subscribeCompany, unsubscribeCompany } from "./../app/features/company";
import LoadingPage from "./loading/index";
import { AppDispatch } from "../app/store";

const AuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [authState, setAuthState] = useState<"loading" | "ok" | "ng">("loading");

  const dispatch = useDispatch<AppDispatch>();
  const auth = getAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        setAuthState("ok");
        dispatch(subscribeCompany(user.uid, user.email ?? ''));
      } else {
        setAuthState("ng");
        unsubscribeCompany();
      }
    });

    return () => {
      unsubscribeAuth();
      unsubscribeCompany();
    };
  }, []);

  // ローディング
  if (authState === "loading") {
    return <LoadingPage />;
  }

  // 未ログイン
  if (authState === "ng") {
    navigate("/company/login", { replace: true });
    return null;
  }

  // OKなら中身表示
  return <>{children}</>;
};

export default AuthGate;
